module.exports = __webpack_public_path__ + "static/media/icon-line.2143b6de.svg";